<template>
  <TableBox :current-page="currentPage" :meta="meta" @onChangePage="$emit('onChangePage', $event)">
    <b-table
      sticky-header
      id="my-table"
      :fields="fields"
      :items="list"
      :busy="isLoading"
      class="custom-table"
      thead-class="custom-table-header"
      tbody-tr-class="custom-table-body"
      :emptyText="$t('text.emptyText')"
      show-empty
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(name)="data">
        <p class="text-truncate" style="max-width: 200px">{{ data.item.name }}</p>
      </template>

      <template #cell(status)="data">
        <Status :value="data.item.isActive" />
      </template>

      <template #cell(date)="data">
        <p class="text-nowrap">
          {{
            `${$options.filters.moment(
              data.item.startDate,
              'YYYY/MM/DD'
            )} - ${$options.filters.moment(data.item.endDate, 'YYYY/MM/DD')}`
          }}
        </p>
      </template>

      <template #cell(link)="data">
        <p class="text-truncate" style="max-width: 150px">{{ data.item.link }}</p>
      </template>

      <template #cell(action)="data">
        <div class="table-action-buttons">
          <InlineButton
            variant="outline-secondary"
            size="sm"
            pill
            @click="$emit('edit', data.item.id)"
            class="has-shadow"
          >
            {{ $t('text.editButton') }}
          </InlineButton>
        </div>
      </template>
    </b-table>
  </TableBox>
</template>

<script>
import TableBox from '@/components/ui/TableBox';
import Status from '@/components/ui/Status';
import InlineButton from '@/components/ui/button/InlineButton';

export default {
  props: {
    list: Array,
    meta: Object,
    currentPage: Number,
    isLoading: Boolean,
  },

  data() {
    return {
      fields: [
        {
          key: 'index',
          label: '#',
        },
        {
          key: 'name',
          label: this.$t('table.th.name'),
        },
        {
          key: 'date',
          label: this.$t('table.th.date'),
        },
        {
          key: 'status',
          label: this.$t('table.th.status'),
        },
        {
          key: 'position',
          label: this.$t('table.th.position'),
        },
        {
          key: 'link',
          label: this.$t('table.th.link'),
        },
        {
          key: 'clickCount',
          label: this.$t('table.th.click'),
        },
        {
          key: 'action',
          label: this.$t('table.th.settings'),
        },
      ],
    };
  },

  components: {
    TableBox,
    Status,
    InlineButton,
  },
};
</script>
